import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { fetchCustomField, fetchCustomFields } from "./api"

export function useFetchCustomFields(entityType?: string | string[], options?: { enabled?: boolean }) {
  const getContext = useApiContext()
  return useQuery({
    queryKey: ["custom_fields", entityType],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchCustomFields(context, entityType)
    },
    enabled: options?.enabled ?? true,
  })
}

export function useFetchCustomField(id: string | null) {
  const getContext = useApiContext()
  return useQuery({
    queryKey: ["custom_field", id],
    enabled: !!id,
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      if (!id) throw new Error("No id found")
      return fetchCustomField(context, id)
    },
  })
}
